var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-cell"},[_vm._t("label",function(){return [_c('div',{class:{ label: !_vm.isSub }},[(_vm.isRequired)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])]}),_c('div',{staticClass:"inline-block mr15",style:({
      marginLeft: _vm.translateGap(_vm.gap) + 'px',
    })},[_vm._t("value",function(){return [_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }